import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import commonEN from './locales/en/common.json';
import authEN from './locales/en/auth.json';
import dashboardEN from './locales/en/dashboard.json';
import approvalEN from './locales/en/approval.json';
import subscriptionEN from './locales/en/subscription.json';
import scheduleEN from './locales/en/schedule.json';
import settingsEN from './locales/en/settings.json';
import profileEN from './locales/en/profile.json';
import uploadEN from './locales/en/upload.json';
import errorsEN from './locales/en/errors.json';
import cookiesEN from './locales/en/cookies.json';
import analyticsEN from './locales/en/analytics.json';
import landingEN from './locales/en/landing.json';
import brandProfileEN from './locales/en/brandProfile.json';
import ecommerceEN from './locales/en/ecommerce.json';

import commonDE from './locales/de/common.json';
import authDE from './locales/de/auth.json';
import dashboardDE from './locales/de/dashboard.json';
import approvalDE from './locales/de/approval.json';
import subscriptionDE from './locales/de/subscription.json';
import scheduleDE from './locales/de/schedule.json';
import settingsDE from './locales/de/settings.json';
import profileDE from './locales/de/profile.json';
import uploadDE from './locales/de/upload.json';
import errorsDE from './locales/de/errors.json';
import cookiesDE from './locales/de/cookies.json';
import analyticsDE from './locales/de/analytics.json';
import landingDE from './locales/de/landing.json';
import brandProfileDE from './locales/de/brandProfile.json';
import ecommerceDE from './locales/de/ecommerce.json';

import commonEL from './locales/el/common.json';
import authEL from './locales/el/auth.json';
import dashboardEL from './locales/el/dashboard.json';
import approvalEL from './locales/el/approval.json';
import subscriptionEL from './locales/el/subscription.json';
import scheduleEL from './locales/el/schedule.json';
import settingsEL from './locales/el/settings.json';
import profileEL from './locales/el/profile.json';
import uploadEL from './locales/el/upload.json';
import errorsEL from './locales/el/errors.json';
import cookiesEL from './locales/el/cookies.json';
import analyticsEL from './locales/el/analytics.json';
import landingEL from './locales/el/landing.json';
import brandProfileEL from './locales/el/brandProfile.json';
import ecommerceEL from './locales/el/ecommerce.json';

import commonIT from './locales/it/common.json';
import authIT from './locales/it/auth.json';
import dashboardIT from './locales/it/dashboard.json';
import approvalIT from './locales/it/approval.json';
import subscriptionIT from './locales/it/subscription.json';
import scheduleIT from './locales/it/schedule.json';
import settingsIT from './locales/it/settings.json';
import profileIT from './locales/it/profile.json';
import uploadIT from './locales/it/upload.json';
import errorsIT from './locales/it/errors.json';
import cookiesIT from './locales/it/cookies.json';
import analyticsIT from './locales/it/analytics.json';
import landingIT from './locales/it/landing.json';
import brandProfileIT from './locales/it/brandProfile.json';
import ecommerceIT from './locales/it/ecommerce.json';

import commonPT from './locales/pt/common.json';
import authPT from './locales/pt/auth.json';
import dashboardPT from './locales/pt/dashboard.json';
import approvalPT from './locales/pt/approval.json';
import subscriptionPT from './locales/pt/subscription.json';
import schedulePT from './locales/pt/schedule.json';
import settingsPT from './locales/pt/settings.json';
import profilePT from './locales/pt/profile.json';
import uploadPT from './locales/pt/upload.json';
import errorsPT from './locales/pt/errors.json';
import cookiesPT from './locales/pt/cookies.json';
import analyticsPT from './locales/pt/analytics.json';
import landingPT from './locales/pt/landing.json';
import brandProfilePT from './locales/pt/brandProfile.json';
import ecommercePT from './locales/pt/ecommerce.json';

// Configure resources
const resources = {
  en: {
    common: commonEN,
    auth: authEN,
    dashboard: dashboardEN,
    approval: approvalEN,
    subscription: subscriptionEN,
    schedule: scheduleEN,
    settings: settingsEN,
    profile: profileEN,
    upload: uploadEN,
    errors: errorsEN,
    cookies: cookiesEN,
    analytics: analyticsEN,
    landing: landingEN,
    brandProfile: brandProfileEN,
    ecommerce: ecommerceEN,
  },
  de: {
    common: commonDE,
    auth: authDE,
    dashboard: dashboardDE,
    approval: approvalDE,
    subscription: subscriptionDE,
    schedule: scheduleDE,
    settings: settingsDE,
    profile: profileDE,
    upload: uploadDE,
    errors: errorsDE,
    cookies: cookiesDE,
    analytics: analyticsDE,
    landing: landingDE,
    brandProfile: brandProfileDE,
    ecommerce: ecommerceDE,
  },
  el: {
    common: commonEL,
    auth: authEL,
    dashboard: dashboardEL,
    approval: approvalEL,
    subscription: subscriptionEL,
    schedule: scheduleEL,
    settings: settingsEL,
    profile: profileEL,
    upload: uploadEL,
    errors: errorsEL,
    cookies: cookiesEL,
    analytics: analyticsEL,
    landing: landingEL,
    brandProfile: brandProfileEL,
    ecommerce: ecommerceEL,
  },
  it: {
    common: commonIT,
    auth: authIT,
    dashboard: dashboardIT,
    approval: approvalIT,
    subscription: subscriptionIT,
    schedule: scheduleIT,
    settings: settingsIT,
    profile: profileIT,
    upload: uploadIT,
    errors: errorsIT,
    cookies: cookiesIT,
    analytics: analyticsIT,
    landing: landingIT,
    brandProfile: brandProfileIT,
    ecommerce: ecommerceIT,
  },
  pt: {
    common: commonPT,
    auth: authPT,
    dashboard: dashboardPT,
    approval: approvalPT,
    subscription: subscriptionPT,
    schedule: schedulePT,
    settings: settingsPT,
    profile: profilePT,
    upload: uploadPT,
    errors: errorsPT,
    cookies: cookiesPT,
    analytics: analyticsPT,
    landing: landingPT,
    brandProfile: brandProfilePT,
    ecommerce: ecommercePT,
  },
};

// Initialize i18next
i18n
  // Use language detector to detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,

    // Language settings
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'el', 'it', 'pt'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'approval', 'subscription', 'schedule', 'settings', 'profile', 'upload', 'errors', 'cookies', 'analytics', 'landing', 'brandProfile', 'ecommerce'],

    // Interpolation settings
    interpolation: {
      escapeValue: false, // React already escapes by default
      // Custom format function for dates, numbers, etc.
      format: (value, format, lng) => {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'lowercase') return value.toLowerCase();
        if (value instanceof Date) {
          return new Intl.DateTimeFormat(lng).format(value);
        }
        return value;
      },
    },

    // Language detection settings
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Where to cache language preference
      caches: ['localStorage'],
      // LocalStorage key name
      lookupLocalStorage: 'i18nextLng',
    },

    // React-specific settings
    react: {
      useSuspense: true, // Use React Suspense for async loading
      bindI18n: 'languageChanged loaded', // Events to bind to
      bindI18nStore: '', // Events to bind to store
      transEmptyNodeValue: '', // What to return for empty Trans nodes
      transSupportBasicHtmlNodes: true, // Allow basic HTML in Trans component
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'em'], // HTML tags to keep
    },

    // Development settings
    debug: false, // Set to true for detailed logging during development

    // Return key if translation is missing
    saveMissing: false,
    missingKeyHandler: (lngs, ns, key) => {
      if (import.meta.env.DEV) {
        console.warn(`Missing translation: [${ns}] ${key}`);
      }
    },
  });

// Set initial lang attribute for accessibility
i18n.on('initialized', () => {
  document.documentElement.lang = i18n.language;
});

// Update lang attribute on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Expose i18n globally only during prerendering (not in production)
if (typeof window !== 'undefined' && window.__PRERENDER_LANDING__) {
  window.i18n = i18n;
}

export default i18n;
